import SocialStatsRow, { SocialStatsRowProps } from './SocialStatsRow';

export default SocialStatsRow;
export type { SocialStatsRowProps };
